import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    padding-block: ${spacing(2)};
  `,
  longTextCell: css`
    padding-inline-start: ${spacing(6)};
    text-align: start;
    word-break: break-word;
  `,
  passportNeed: css`
    margin-block: ${spacing(1)};
    margin-inline: 0;
    background-color: ${cssTheme.default.day.backgroundMinor};
    border-radius: ${spacing(2)};
    text-align: start;
  `,
}
